exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (min-width: 993px) {\n.search[data-v-0eaeafc6] {\n    margin-top: 80px;\n}\n}\n@media (max-width: 992px) {\n.search[data-v-0eaeafc6] {\n    margin-top: 44px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0eaeafc6","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/requests/ContactDebtorList.vue
// module id = 1502
// module chunks = 2